//
//
//
//
//
//
//
//
export default {
  name: "chat_helper",
  data: function data() {
    return {
      tableData: []
    };
  },
  created: function created() {},
  methods: {}
};